// extracted by mini-css-extract-plugin
module.exports = {"count":"fk_XSS4l","tabItem":"_35qcoCpZ","tabItemActive":"_3d3meOmy","ticketsItem":"_1zNMTFZ5","hotelsItem":"_10mE_3ee","cartItem":"_1WeCjfLJ","spinner":"L3h6472i"};